import { Component, OnInit, VERSION } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { USER_TYPE } from '../../../../../includes/global'
import { CompanyService } from 'src/app/services/Modules/company.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { startWith, map } from 'rxjs/operators';
import { UserService } from 'src/app/services/Modules/user.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FacilityService } from 'src/app/services/facility.service';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import moment from 'moment';
import TextSignature from 'text-signature';
import { TITLES } from 'src/app/constants/userTitles.constants';

const user_types = {
    'provider': USER_TYPE.DOCTOR,
    'company': USER_TYPE.DOCTOR,
    'transcriber': USER_TYPE.TRANSCRIBER,
    'manager': USER_TYPE.MANAGER,
    'pa': USER_TYPE.PA,
    'nurse': USER_TYPE.NURSE,
    'biller': USER_TYPE.BILLER,
    'medical_assistant': USER_TYPE.MEDICAL_ASSISTANT,
    'business_officer': USER_TYPE.BUSINESS_OFFICER,
    'snf_wc_nurse': USER_TYPE.SNF_WC_NURSE,
}


@Component({
    selector: 'app-company-user-management-form',
    templateUrl: './company-user-management-form.component.html',
    styleUrls: ['./company-user-management-form.component.css']
})
export class CompanyUserManagementFormComponent implements OnInit {
    data: any = {
        fontColor : "Black",
        fontSize:  "16",
        image_height: "",
        image_width: "",
        image_padding_x:"",
        image_padding_y:"",
        mendatory:false
        }
    fontSizes = [ '12','14', '16', '18', '20', '22', '24', '26']

    USER_TYPE = USER_TYPE;
    loaderId = 'company-user-management-form-loader';
    model :any = {
        user_type: '',
        title: '',
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        speciality: '',
        // password: '',
        company_id: null,
        cc_email: 'management@doctornow.io',
        country: '',
        trueRCMID: null,
        companyCode: '',
        npi: '',
        titleArray:[],
        tin: ''
    }
    user_id: string;
    phoneCleaned = '';
    dataSource: MatTableDataSource<any>;
    dataSource2: MatTableDataSource<any>;
    facilityControl = new FormControl();
    filteredFacilities: Observable<string[]>;
    typesOfShoes: string[] = ['Boots', 'Clogs', 'Loafers', 'Moccasins', 'Sneakers'];

    titles = [];
    titleControl = new FormControl();
    facilities: any = [];
    displayedColumns = ['facility', 'checkbox']
    selectedFacilityDisplayedColumns = ['checkbox', 'facility', 'note_uploading_method']
    selectedFacilities: any = [];
    facilityError: boolean = true;
    product_owner: boolean;
    selectedCountry: any;
    isIRCCompany: boolean;
    companyCode: any;
    company: any;
    companyType: any;
    pcc_note_uploading_method_per_facility:  {
        facility_id: string,
        note_uploading_method: 'progress_note'|'pdf_document'|'encounter_note';

    }[] = [];

    selectAllFacility = false;
    displayProviderFn(title): string {
        return title;
    }
    companies: any = [];
    selectedCompany: any;
    Country = ['US / CA(+1)', 'Philippines(+63)', 'Pak(+92)', 'Ind(+91)'];
    maxMobileLength = 12;
    providerDropdownSettings: any = {};
    public provider_titles = TITLES;

    constructor ( private _location: Location,
        private _current_user: AuthService,
        private route: ActivatedRoute,
        private companyService: CompanyService,
        private userService: UserService,
        private loader: NgxUiLoaderService,
        private facilityService: FacilityService,
        private toastr: ToastrService,
        private commonService: CommonService
    ) {
        this.model.company_id = this.route.parent.parent.snapshot.params.id;
        this.user_id = this.route.snapshot.params.id;
      
        this.providerDropdownSettings = {
            singleSelection: false,
            idField: '_id',
            textField: 'full_name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 10,
            allowSearchFilter: true,
        };
    }

    async ngOnInit() {
        await this.getCompanyName();
        if (this.company.company_type !== 'Wound') {
            this.isIRCCompany = true;
        }
        this.product_owner = this._current_user.currentUser.product_owner
        this.dataSource2 = new MatTableDataSource(this.selectedFacilities);
        this.dataSource = new MatTableDataSource(this.facilities);
        this.getAllCompanies()
        await this.initFacilities();
        if (this.user_id) {
            this.loader.startLoader(this.loaderId);

            const filter = {
                _id: this.user_id
            }
            const projection = {
                user_type: 1,
                title: 1,
                first_name: 1,
                last_name: 1,
                email: 1,
                mobile: 1,
                company_id: 1
            }

            this.userService.getUser(filter, projection).subscribe((response: any) => {
                if (response.status === 200) {
                    this.model = response.data;

                    const { user_type } = this.model;
                    for (const key in user_types) {
                        if (user_types[key] == user_type) {
                            this.model.user_type = key;
                            break;
                        }
                    }

                }
                this.loader.stopLoader(this.loaderId);
            })

        }

        this.model.tin = this.company.tin;
        this.titles = this.provider_titles;
      

    }

    async getCompanyName() {
        const companyName = await this.companyService.getCompanyName(this.model.company_id).toPromise()
        this.company = companyName.data;
        this.companyType = this.company.company_type;            
    }
  


    initFacilities = async () => {
        const company_id = this.route.parent.parent.snapshot.params.id;

        const filter = {
            is_active: true,
            company_id
        }
        const projection = {
            'title': 1,
            'address': 1,
            'city': 1,
            'state': 1,
            'zip_code': 1,
            'provider_ids_ref': 1,
        }

        const facilitiesResponse: any = await this.facilityService.getAllFacilities(filter, projection).toPromise();

        if (facilitiesResponse.status === 200) {
            this.facilities = new MatTableDataSource(facilitiesResponse.data.array);
            this.facilities.data.forEach(element => {
                element.selected = false;
            });

        }
    }

    updateFacilities = async (value) => {
        const company_id = value;
        const filter = {
            is_active: true,
            company_id
        }
        const projection = {
            'title': 1,
            'address': 1,
            'city': 1,
            'state': 1,
            'zip_code': 1,
            'provider_ids_ref': 1,
        }
        const facilitiesResponse: any = await this.facilityService.getAllFacilities(filter, projection).toPromise();
        if (facilitiesResponse.status === 200) {
            this.facilities = new MatTableDataSource(facilitiesResponse.data.array);
            this.facilities.data.forEach(element => {
                element.selected = false;
            });
        }
        this.selectedFacilities = [];
        this.dataSource2 = new MatTableDataSource(this.selectedFacilities);
        this.selectAllFacility = false;
    }

    handlePhoneModelChange(value) {
        if (this.selectedCountry === 'Philippines(+63)') {
            this.model.mobile = value;
            this.phoneCleaned = value;
        }
        else if (value) {
            const cleaned = value.replace(/-/g, '')
     
            if(this.selectedCountry === 'Ind(+91)') {
                this.model.mobile = cleaned.match(/.{1,4}/g).join('-');
                if(this.model.mobile.length > 9) {
                    let tempNum = this.model.mobile.split('-');
                    let num = [tempNum[0], tempNum[1]+ tempNum[2]];
                    this.model.mobile = num.join('-');
                }
                
            }
            else {
                this.model.mobile = cleaned.match(/.{1,3}/g).join('-');
            }
            
            if (this.model.mobile.length > 12) {
                let position = this.model.mobile.lastIndexOf('-');
                this.model.mobile = this.model.mobile.substring(0, position) + this.model.mobile.substring(position + 1);
            }

            this.phoneCleaned = cleaned.trim();
         
        }
    }
    onPaste(event: ClipboardEvent) {
        let clipboardData = event.clipboardData;
        let pastedData = clipboardData.getData('Text').toString();
        let number: any = pastedData.match(/\d/g);
        number = number.join("");
        if (number.length > 10) {
            number = number.substring(0, 10);
        }
        this.handlePhoneModelChange(number);
        
    }

    selectAllFacilities($event) {
        if ($event.checked) {
            this.facilities.data.forEach(element => {
                this.selectedFacilities.push(element);
                element.selected = true;
            });
            this.dataSource2 = new MatTableDataSource(this.selectedFacilities);
        } else {
            this.facilities.data.forEach(element => {
                element.selected = false;
            });
            this.selectedFacilities = [];
            this.dataSource2 = new MatTableDataSource(this.selectedFacilities);
        }
    }

    addFacilities(fac) {
        let facility = fac.data;
        this.selectAllFacility = false;
   
        let index = this.facilities.data.indexOf(fac);
        if (fac.selected === false) {
            fac.selected = true;
            this.facilities.data.splice(index, 1, fac);
            this.selectedFacilities.push(fac);

            if(this.isNoteUploadingMethodAllowed(fac)) {
                this.pcc_note_uploading_method_per_facility.push({
                    facility_id: fac._id,
                    note_uploading_method: this.company.note_uploading_method
                })
            }
            // to detect change for mat table
            this.dataSource2 = new MatTableDataSource(this.selectedFacilities);

        }
        else if (fac.selected === true) {
            this.selectedFacilities.splice(this.selectedFacilities.indexOf(fac), 1);
            // to detect change for mat table
            this.dataSource2 = new MatTableDataSource(this.selectedFacilities);

            fac.selected = false;
            this.facilities.data.splice(index, 1, fac);
            if(this.isNoteUploadingMethodAllowed(fac)) {
                this.pcc_note_uploading_method_per_facility.splice(this.pcc_note_uploading_method_per_facility.findIndex((item) => item.facility_id === fac._id), 1);
            }
        }
        if (this.model.user_type === 'provider' && this.selectedFacilities.length > 0) {
            this.facilityError = false;
        }
        if (this.model.user_type === 'provider' && this.selectedFacilities.length === 0) {
            this.facilityError = true;
        }
        if (this.facilities.data.length == this.selectedFacilities.length) {
            this.selectAllFacility = true;
        }

    }

    removeFromSelectedFacilities(facility) {
        this.selectedFacilities.splice(this.selectedFacilities.indexOf(facility), 1);
        // to detect change for mat table
        this.dataSource2 = new MatTableDataSource(this.selectedFacilities);

        facility.selected = false;
        this.facilities.data.splice(this.facilities.data.indexOf(facility), 1, facility);
        if (this.model.user_type === 'provider' && this.selectedFacilities.length > 0) {
            this.facilityError = false;
        }
        if (this.model.user_type === 'provider' && this.selectedFacilities.length === 0) {
            this.facilityError = true;
        }
        this.selectAllFacility = false;
    }


    goBack() {
        this._location.back();
    }

    getUserType(type) {

        return user_types[type];

    }

    applyFilter(filterValue: string) {

        this.dataSource2.filter = filterValue.trim().toLowerCase();
    }

    applyFilter2(filterValue: string) {

        this.facilities.filter = filterValue.trim().toLowerCase();
    }

    handleSubmit(e) {
      
        if (!e.valid) return;
        this.model.email = this.model.email.toLowerCase();
        this.model.email.replace( /\s/g, '');
        this.model.cc_email = this.model.cc_email.toLowerCase();
        this.model.cc_email.replace( /\s/g, '');
        const user_type = this.getUserType(this.model.user_type);
        if (this.selectedCountry === 'Pak(+92)') {
            this.phoneCleaned = '+92' + this.phoneCleaned;
        }
        else if (this.selectedCountry === 'US / CA(+1)') {
            this.phoneCleaned = '+1' + this.phoneCleaned;
        }
        else if (this.selectedCountry === 'Philippines(+63)') {
            this.phoneCleaned = '+63' + this.phoneCleaned;
        }
        else if(this.selectedCountry === 'Ind(+91)') {
            this.phoneCleaned = '+91' + this.phoneCleaned;
        }
       
        /// handle model maen title of prov

        this.model.pcc_note_uploading_method_per_facility = this.pcc_note_uploading_method_per_facility;
        const model = { ...this.model };
        model.mobile = this.phoneCleaned;
        if(localStorage.getItem('companyCode')){
            this.companyCode = localStorage.getItem('companyCode');
            model.companyCode = this.companyCode;
        }

        const data: any = {
            ...model,
            user_type
        }

        if (this.selectedFacilities.length > 0) {
            data.facilities = this.selectedFacilities.map(ele => { return ele = ele._id });
        }

     

        try {
            this.loader.startLoader(this.loaderId);
            if (this.user_id) {
                this.userService.updateUser(data).subscribe((response: any) => {
                    this.loader.stopLoader(this.loaderId);
                    this.toastr.success('User added succesfully', 'Success')
                    this.goBack();
                })
            } else {
                let dateTime = this.commonService.convertDateToStringforMoment(moment(),true);
                data.dateTime = dateTime; //changes
                data.creatorId = this._current_user.currentUser._id;
                this.companyService.addUser(data).subscribe(
                    (res) => {
                        this.loader.stopLoader(this.loaderId);
                        if (res.status === 200) {
                            this.createSignature(res.data)
                            this.toastr.success('User added successfully', 'Success');
                            this.goBack();
                        } else {
                            this.toastr.error('Email already exist', 'Error');
                            this.phoneCleaned, this.model.mobile = "";
                        }
                    }
                );
            }
        } catch (error) {
            this.loader.stopLoader(this.loaderId);
            this.toastr.error('Something went wrong', 'Error');
        }
    }
    
    async createSignature(data:any){
        let optionsParameter = {
            width: this.calculateWidth(data),
            height: this.calculateHeight(),
            paddingX: "3",
            paddingY: this.data.fontSize,
            canvasTargetDom: "#can",
            font: [this.data.fontSize+"px", "'Homemade Apple'"],   
            color: "black",
            textString: "",
            customFont: {
              name: "'Homemade Apple'",
              url: "https://fonts.googleapis.com/css?family=Homemade+Apple"
            }
          };
          optionsParameter.textString=`${data.first_name} ${data.last_name}, ${data.title}`
          let textSignature = new TextSignature(optionsParameter);
          let can = textSignature.generateImage(optionsParameter);
          let imgData = textSignature.getImageData();
          let body ={
              id: data._id,
              auth_key: this._current_user.currentUser.auth_key,
              fontColor:'Black',
              fontSize: '16px',
              image_height:'75px',
              mendatory:true,
              image:imgData, 
            }
        let response : any = await this.userService.saveSignatureSettings(body).toPromise()
    }

    calculateWidth(data:any){
       let index =  this.fontSizes.indexOf(this.data.fontSize+"");
       var myString = this.data.first_name+""+this.data.last_name+""+this.data.title+"";
       var stringLength = myString.length;
       let width  = 50+((index + 1)*14)+(stringLength*12)
       return width 
    }

    calculateHeight(){
        let index =  this.fontSizes.indexOf(this.data.fontSize+"");
        let height  = 18+((index * 1.3))
        return height
    }

    getAllCompanies() {
        if (this.product_owner) {
            this.companyService.getAllCompanies().subscribe((response: any) => {
                if (response.status == 200) {
                    this.companies = response.data
                }
                else if (response.status == 403) {
                    this.toastr.error(response.message, "ERROR");
                }
            })
        }
        else if (this._current_user.currentUser.admin_type === "full_admin" || this._current_user.currentUser.admin_type === "system_admin" ) {
            this.companyService.getCompanyName(this.model.company_id).subscribe((response: any) => {
                if (response.status == 200) {
                    this.companies.push(response.data);
                }
            });
        }
    }
    allowOnlyText(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 90 && charCode < 97) {
            return false;
        }

        if (charCode < 65 || charCode > 122) {
            return false;
        }
        return true;
    }
    keyPressNumbers(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        // Only Numbers 0-9
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        }
        else {
            return true;
        }
    }
    countryFilter(Country) {
        this.phoneCleaned = "";
        this.model.mobile = "";
        if (Country == 'US / CA(+1)') {
            this.selectedCountry = Country;
            this.maxMobileLength = 12;
           
        }
        else if (Country === 'Philippines(+63)') {
            this.selectedCountry = Country;
            this.maxMobileLength = 10;
        }
        else if (Country === 'Pak(+92)') {
            this.selectedCountry = Country;
            this.maxMobileLength = 12;
            
        }
        else if(Country === 'Ind(+91)') {
            this.selectedCountry = Country;
            this.maxMobileLength = 11;
        }
    }
    
    changeUserType($event) {
        if($event == 'provider' || $event == 'test_provider' || $event == 'cnp') {
            this.titles = this.provider_titles;
        }
        else {
            if(this.model.title == "APN" ||  this.model.title =="LCSW" ||  this.model.title ==  "PshycNP" ||  this.model.title == "PsyD" ||  this.model.title == "FNP" ||  this.model.title == "NP-C" || this.model.title == 'FNP-C') {
                this.model.title = "";
            }
            this.titles = ["M.D.", "D.O.", "PA-C", "ARNP", "R.N.", "N.P.", "P.A.", "L.Ac", "DNP", "CWS", "CWSP", "WOCN"];
        }
        if($event === 'test_provider'){
            this.model['additionalUserRole'] = 'demo_provider';
            this.model.user_type = 'provider';
        }
        else if($event === 'cnp'){
            this.model['additionalUserRole'] = 'cnp';
            this.model.user_type = 'provider';
        }
    }

    isOptionVisibleForCompany( option ) {
        const companyId = this.route.parent.parent.snapshot.params.id;
        return this.userService.isOptionVisibleForCompany( option, companyId);
      }
    

  
    onSelectAllTitle($event) {
        this.model.title=$event;
    
    }
    onDeSelectAllTitleAll($event) {
        this.model.title='';
       
    }
   
    shouldShowTitle() {
        if(this.companyType?.toLowerCase() === 'wound'){
            return true
        }
        else if(this.model.user_type === 'provider' || this.model.user_type === 'snf_wc_nurse'){
            return true
        }
    }
    
    getCompanyUploadingMethods(company_type:string, facility?:any){
        return this.companyService.getCompanyUploadingMethods(company_type, facility?.source);
    }

    handleNoteUploadingMethodChange(facility, value) {
        // check if facility is already in the list
        const alreadyExists = this.pcc_note_uploading_method_per_facility.find((item) => item.facility_id === facility._id);
        if (alreadyExists) {
            alreadyExists.note_uploading_method = value;
        } else {
            this.pcc_note_uploading_method_per_facility.push({
                facility_id: facility._id,
                note_uploading_method: value
            })
        }
    }
    isNoteUploadingMethodAllowed(facility) {
        return this.model.user_type === 'provider' && (facility.source === 'PointClickCare' || facility.source === 'MatrixCare');
    }
    getSelectedFacilityNoteUploadingMethod(facility) {
        return this.pcc_note_uploading_method_per_facility.find((item) => item.facility_id === facility._id)?.note_uploading_method;
    }
}

